import { render, staticRenderFns } from "./newsSlider.vue?vue&type=template&id=083fb8ba&scoped=true"
import script from "./newsSlider.vue?vue&type=script&lang=js"
export * from "./newsSlider.vue?vue&type=script&lang=js"
import style0 from "./newsSlider.vue?vue&type=style&index=0&id=083fb8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fb8ba",
  null
  
)

export default component.exports